import Swal from 'sweetalert2';

export const msg = (icon, title, text) => {
    Swal.fire({ icon, title, text, timer: 4000 });
};